module.exports = __webpack_public_path__ + "img/aa43049b70758152d67355a46b2fdb01.png";